<script>
export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            id: 2,
            _name: "CSidebarNavItem",
            name: `CHAT ANALYSIS`,
            to: "/chat-analysis",
            icon: "cil-bar-chart",
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `FLOW BUILDER`,
            to: "/flow-builder",
            icon: "cil-settings",
          },
          {
            id: 3,
            _name: "CSidebarNavItem",
            name: `MESSAGE LOG`,
            to: "/message-log",
            icon: "cil-list",
          },
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: `IMAGE MAP`,
            to: "/image-map",
            icon: "cil-image",
          },
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: `SENTIMENT TRAINING`,
            to: "/sentiment-training",
            icon: "cil-comment-bubble",
          },
          {
            id: 5,
            _name: "CSidebarNavItem",
            name: `SETTING TIME`,
            to: "/setting-time",
            icon: "cil-settings",
          },
          // {
          //   id: 6,
          //   _name: "CSidebarNavItem",
          //   name: `EMAIL CONFIG`,
          //   to: "/email-config",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 5,
          //   _name: "CSidebarNavItem",
          //   name: `SETTING WIDGET`,
          //   to: "/setting-widget",
          //   icon: "cil-settings",
          // },
          {
            id: 7,
            _name: "CSidebarNavItem",
            name: `USER`,
            to: "/user",
            icon: "cil-user",
          },
          {
            id: 8,
            _name: "CSidebarNavItem",
            name: `CHAT`,
            to: "/chat",
            icon: "cil-chat-bubble",
            showIf: this.$route.query.brandID == 6 || this.$route.query.brandID == 7 || this.$route.query.brandID == 8,
          },
        ],
      },
    };
  },
  computed: {
    sidebarItems() {
      // return [this.sidebar];
      return [
        {
          _name: "CSidebarNav",
          _children: this.filterMenu(this.sidebar._children),
        },
      ];
    },
  },
  created: async function() {},
  methods: {
    filterMenu(list) {
      return list.filter((item) => {
        return item.showIf != false;
      });
    },
  },
};
</script>
